import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-dynamic-value',
    template: `
        <span class="dynamic-value" [ngClass]="{'is-masked': isLoading}">
            <ng-content></ng-content>
        </span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class DynamicValueComponent {
    @Input() isLoading?: boolean | undefined | null = false;
}